import React, { useState, useEffect } from "react";
import PolicyContainer from "./PolicyContainer";

import { Container, Content, Description, ButtonContainer } from "./styles";
const Cookies = () => {
  const [policyContainer, setPolicyContainer] = useState(false);
  const [cookies, setCookies] = useState(false);

  useEffect(() => {
    const cookie = localStorage.getItem("cookies");
    if (cookie !== "accepted") setCookies(true);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookies", "accepted");
    setCookies(false);
  };

  return (
    <>
      <Container>
        {cookies && (
          <Content>
            <Description>
              <p>
                Ao navegar neste site, você aceita os cookies que usamos para
                melhorar sua experiência.{" "}
              </p>
            </Description>
            <ButtonContainer>
              <button onClick={() => acceptCookies()}>Aceitar</button>
            </ButtonContainer>
          </Content>
        )}
      </Container>

      <PolicyContainer
        active={policyContainer}
        handler={() => setPolicyContainer(false)}
      />
    </>
  );
};

export default Cookies;
